import { render, staticRenderFns } from "./AdminPaginationBar.vue?vue&type=template&id=8ee42248&"
import script from "./AdminPaginationBar.vue?vue&type=script&lang=js&"
export * from "./AdminPaginationBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports